import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Navbar,
  Nav,
  Card,
  Badge,
  Image,
  Offcanvas,
} from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Navigate, useNavigate } from "react-router-dom";
import {
  FaWhatsapp,
  FaFilePdf,
  FaShippingFast,
  FaPlane,
  FaShip,
  FaRocket,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaUserPlus,
  FaShoppingCart,
  FaWarehouse,
  FaHome,
  FaGift,
  FaCheckCircle,
  FaExclamationTriangle,
  FaDollarSign,
  FaHeadset,
  FaInstagram,
  FaFacebook,
  FaTiktok,
  FaShareAlt,
  FaClock,
  FaBox,
  FaMapMarkedAlt,
  FaTag,
  FaCreditCard,
  FaTruck,
  FaBoxOpen,
  FaLock,
  FaSmile,
  FaCalendarAlt,
  FaArrowUp,
  FaArrowDown,
  FaChevronRight,
  FaTimes,
  FaPlayCircle,
  FaPlay,
  FaBoxes,
  FaPallet,
  FaPlaneDeparture,
} from "react-icons/fa";

import { Player } from "@lottiefiles/react-lottie-player";
import { motion } from "framer-motion";

import inicio from "../../assets/inicio.png";
import logoMbox from "../../assets/MBOX-LOGO-BLANCO.png";
import video1 from "../../assets/Video1.mp4";
import video2 from "../../assets/Video2.mp4";
import video3 from "../../assets/video3.mp4";
import video4 from "../../assets/video4.mp4";

import mboxitoMexico from "../../assets/mboxitoMexico.png";
import mboxitoEEUU from "../../assets/mboxitoEEUU.png";

import deliveryAnim from "../../assets/Animation - 1748224957909.json";
import mascota from "../../assets/MBOXITO_MASCOTA.png";
import trackingAnimation from "../../assets/Animation - 1747624631532.json";
import boxAnimation from "../../assets/Animation - 1747626198371.json";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";

import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";


const RepackagingSection = () => {
  const navigate = useNavigate();
  return (
    <section
          id='reempaque'
          className='py-5 bg-gradient-primary'
          style={{ color: "#182848" }}
        >
          <Container>
            <Row className='align-items-center'>
              <Col lg={6}>
                <h2 className='display-5 fw-bold mb-4'>
                  Reempaque <span className='text-warning'>gratuito</span> de
                  tus paquetes
                </h2>
                <p className='lead mb-5 opacity-75'>
                  En MBOX te ofrecemos el servicio de reempaque completamente
                  gratuito. Este servicio consiste en reorganizar y compactar
                  tus paquetes para disminuir el peso volumétrico y aprovechar
                  mejor el espacio, logrando así un ahorro real en tu envío
                  internacional.
                </p>

                <div className='d-flex flex-column gap-4'>
                  {[
                    {
                      title: "¿Cómo funciona?",
                      description:
                        "Solo debes completar el formulario indicando los paquetes que deseas reempacar, utilizando el número de seguimiento proporcionado por la tienda donde realizaste tu compra.",
                    },
                    {
                      title: "⚠️ Importante",
                      description:
                        "Este servicio aplica únicamente para tracking numbers previamente registrados y confirmados en nuestro sistema.",
                    },
                    {
                      title: "Confirmación",
                      description:
                        "Una vez envíes el formulario, nuestro equipo revisará la solicitud y te enviaremos la confirmación directamente por WhatsApp, para que tengas la seguridad de que tu reempaque ha sido procesado.",
                    },
                  ].map(({ title, description }, idx) => (
                    <div key={idx} className='d-flex align-items-start gap-3'>
                      <div
                        className='rounded-circle d-flex align-items-center justify-content-center'
                        style={{
                          width: 44,
                          height: 44,
                          flexShrink: 0,
                          fontWeight: "700",
                          fontSize: "1.25rem",
                          color: "white",
                          backgroundColor: "#182848",
                          userSelect: "none",
                          boxShadow: "0 0 8px rgba(0,0,0,0.3)",
                        }}
                        aria-label={`Paso ${idx + 1}`}
                      >
                        {idx + 1}
                      </div>
                      <div>
                        <h5 className='mb-1 fw-semibold'>{title}</h5>
                        <p className='mb-0 opacity-75'>{description}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <div className='mt-4'>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      window.scrollTo(0, 0);
                      navigate("/solicitud-reempaque");
                    }}
                    className='btn btn-primary'
                  >
                    Crear solicitud de reempaque
                  </button>
                </div>
              </Col>
              <Col lg={6} className='mb-5 mb-lg-0'>
                <div
                  className='bg-light rounded-circle d-flex align-items-center justify-content-center mx-auto position-relative'
                  style={{
                    width: "100%",
                    maxWidth: "450px",
                    aspectRatio: "1/1",
                    boxShadow: "0 20px 40px rgba(0,0,0,0.08)",
                    border: "10px solid #f8f9fa",
                  }}
                >
                  <div
                    className='position-absolute w-100 h-100 rounded-circle'
                    style={{
                      background:
                        "linear-gradient(135deg, #e0eafc 0%, #cfdef3 100%)",
                      opacity: 0.5,
                      zIndex: 1,
                    }}
                  ></div>
                  <FaBoxOpen
                    size={160}
                    style={{ color: "#3a5a8a", zIndex: 2 }}
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </section>
  );
};

export default RepackagingSection;
